import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { format, isValid, parseISO } from 'date-fns';
import { ReportDateSelectorProps } from './ReportDateSelector.props';

const DATE_PARAM_FORMAT = 'yyyy-MM-dd';

const ReportDateSelector: FC<ReportDateSelectorProps> = ({ value, onChange }) => (
  <Box display="flex" alignItems="center" gap={1}>
    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: 12, whiteSpace: 'nowrap' }}>
      Report date
    </Typography>
    <DatePicker
      value={value ? parseISO(value) : null}
      onChange={newValue => {
        if (newValue && isValid(newValue)) {
          onChange(format(newValue, DATE_PARAM_FORMAT));
        }
      }}
      slotProps={{
        textField: {
          id: 'daily-nav-report-date',
          size: 'small',
          sx: {
            width: 160,
            '& .MuiInputBase-input': { fontSize: 12, paddingY: 0.5 },
          },
        },
      }}
    />
  </Box>
);

export default ReportDateSelector;
